S.navMain =
    {
        config: {
            // delay beim sliddown click desktop
            slideDownDelay: 500,

            // Tabmodus open Level 2 (true)
            openLevel2Tab: true,

            // animationszeit beim sliddown click wenn 1 Layer bereits offen ist
            slideDownDelayOpenSlideFrom: 0,

            // delay slideup click desktop
            slideUpDelay: 400,

            // slideFrom = horizontale Navi
            // sonst accordion untereinander (mobile)
            // check desktop
            // slideFrom: 'desktop',
            slideFrom: null,

            // hover ab Mediaquery z.B. hoverFrom: desktop
            hoverFrom: null,

            // NEW no hover module |only mobile
            disableHover: false,

            // delay des sliders wenn anderer bereits offen ist
            slideOpenDelay: 0,

            // ab slideFrom: delay des sliders wenn anderer bereits offen ist
            // sollte minimum slideUpDelay betragen
            slideOpenDelaySlideFrom: 0,

            // click accordion scroll top
            scrollTop: true,

            // mobile alles ausklappen (alles bevor slideFrom)
            // bei true S.slide.openAllSlides(); im headerjs notwendig !!!!
            openAllSlidesbeforeSlideFrom: false,

            // need js-m-scrolltop inside define scrollarea mobile for scrollTop Option
            // e.g scrollTopCointainer: #footer_navigation
            scrollTopCointainer: '#navigation',
        },

        elements: {
            // ggf bei hover parent element
            $slide: null,
            $slideHead: null,
            $slideContent: null,
        },

        init($module, config, elements)
        {
            let setdelay = 0;
            let slideDownTime = 0;
            const slide = elements.$slide;
            const head = elements.$slideHead;
            const content = elements.$slideContent;

            // erstes li element in main nav level1 + level2
            $('.mod-nav-main >ul li:first-child').addClass('m-first-li');
            // letztes li element in main nav level1
            $('.mod-nav-main >ul >li:last-child').addClass('m-last-li');
            // vorletztes li element in main nav level1
            $('.mod-nav-main >ul >li:nth-last-child(2)').addClass('m-second-last-li');

            // https://stackoverflow.com/questions/4817029/whats-the-best-way-to-detect-a-touch-screen-device-using-javascript
            // if(!this.isTouchDevice() && config.slideFrom && S.mq(config.slideFrom, true).matches) {
            // this.toggleKeyTab();
            // }

            // Higlight Anker Kontakt
            // $('#navigation').find('a').on('click tap', function ()
            // {
            //     if($(this).attr('href')==='#kontakt') {
            //         $('#navigation').find('a').removeClass('is-active-page');
            //         // alert($(this).attr('href'));
            //         $(this).addClass('is-active-page');
            //     }
            // });

            // Link Tags nicht folgen wenn slides vorhanden
            const setPreventDefault = () =>
            {
                // anchor setup nav
                $('.is-close-mobile-nav').on('click tap', function ()
                {
                    S.header.closeMobileNav();
                    S.bglayer.close();
                    // $('.mod-bglayer').stop().fadeOut();
                    // $('.mod-bglayer').removeClass('is-active');
                });

                head.on('click tap', function (e)
                {
                    // if ($(this).next().hasClass('js-slide-content') === true)
                    // e.stopPropagation();
                    e.preventDefault();
                });
            };

            const activeHighlight = () =>
            {
                head.on('click tap', function ()
                {
                    // const href = ($(this).attr('href'));

                    head.removeClass('is-active-click');

                    if ($(this).next('.js-slide-content').is(':hidden'))
                    {
                        $(this).addClass('is-active-click');
                    }
                });
            };

            // allowOpenSlide
            const allowOpenSlide = () =>
            {
                if (config.openAllSlidesbeforeSlideFrom === true)
                {
                    if (config.slideFrom && S.mq(config.slideFrom, false).matches)
                    {
                        return true;
                    }
                }
                else
                {
                    return true;
                }

                return false;
            };


            // location.href
            const locationHref = (url) =>
            {
                setTimeout(function ()
                {
                    // console.log(url.attr('href'));
                    location.href = url.attr('href');
                }, config.slideUpDelay);
            };


            // close slide
            const closeSlide = (slidecontent) =>
            {
                slidecontent.stop().slideUp(config.slideUpDelay);

                setTimeout(function ()
                {
                    $('#navigation').removeClass('is-menue-open');
                }, 10);
            };


            // open slide
            const openSlide = (slidecontent) =>
            {
                if ($('#navigation').hasClass('is-menue-open'))
                {
                    slideDownTime = config.slideDownDelay;
                    if (config.slideFrom && S.mq(config.slideFrom, false).matches)
                    {
                        slideDownTime = config.slideDownDelayOpenSlideFrom;
                    }
                }
                else
                {
                    slideDownTime = config.slideDownDelay;
                }

                if (content.is(':visible'))
                {
                    setdelay = config.slideOpenDelay;
                    if (config.slideFrom && S.mq(config.slideFrom, false).matches)
                    {
                        setdelay = config.slideOpenDelaySlideFrom;
                    }
                }
                else
                {
                    setdelay = config.slideOpenDelay;
                }

                // close open slides
                // if (config.closeOpenSlides === true) (gibt zuviele Probleme)

                content.stop().slideUp(config.slideUpDelay);

                // scrolltop

                // alert($(window).height());
                if (content.is(':visible') && $(window).scrollTop() > ($(window).height()))
                {
                    // $('html').animate({
                    //     scrollTop: $module.position().top,
                    // }, config.slideUpDelay);
                }

                if (config.scrollTop)
                {
                    $(config.scrollTopCointainer + ' .js-m-scrolltop').animate({
                        scrollTop: 0,
                    }, config.slideUpDelay);
                }

                // open clicked slide
                slidecontent.stop().height('auto').delay(setdelay).slideDown(slideDownTime);

                // desktop only change url to data-desktop-url
                // not required
                // $('a').each((index, e) =>
                // {
                //     if (typeof $(e).data('desktop-url') !== 'undefined')
                //     {
                //         const url = $(e).data('desktop-url');
                //         $(e).attr('href', url);
                //     }
                // });

                setTimeout(function ()
                {
                    $('#navigation').addClass('is-menue-open');
                }, 20);
            };


            // initSlidesClick
            const initSlidesClick = () =>
            {
                // standard immer per click
                head.on('click tap', function ()
                {
                    const actContent = $(this).next('.js-slide-content');

                    // open
                    if (actContent.is(':hidden'))
                    {
                        // open act slide
                        openSlide(actContent);
                    }

                    // close
                    else if (actContent.is(':visible'))
                    {
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }
                    }

                    // close all + redirect
                    else
                    {
                        // no act slide exist, close all open slides
                        // if ($(this).next().hasClass('js-slide-content') === false)
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }

                        locationHref($(this));
                    }
                });
            };

            // initSlidesHover
            const initSlidesHover = () =>
            {
                slide.hover(
                    function ()
                    {
                        head.removeClass('is-active-click');
                        head.removeClass('is-focus');
                        const actContent = $(this).children('.js-slide-content');

                        // open
                        if (actContent.is(':hidden'))
                        {
                            // open act slide
                            openSlide(actContent);
                        }

                        // close
                        else if (actContent.is(':visible'))
                        {
                            if (allowOpenSlide() === true)
                            {
                                closeSlide(actContent);
                            }
                        }
                    },
                    function ()
                    {
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }
                    },
                );

                // standard immer per click
                head.on('click tap', function ()
                {
                    const actContent = $(this).next('.js-slide-content');
                    // const href = ($(this).attr('href'));

                    // js link only
                    // menue bei key steuerung auch öffnen bei a-tags
                    // if (href.indexOf('/') === -1)
                    // {
                    // open
                    if (actContent.is(':hidden'))
                    {
                        // alert(':hidden');
                        // open act slide
                        openSlide(actContent);

                        // Level 3 bei desktop nicht öffnen

                        // desktop level 3 level3 nicht klickbar (nur mobile)
                        // if (actContent.attr('class').indexOf('mod-nav-main-level2level3') === -1)
                        // {
                        //     openSlide(actContent);
                        // }
                    }

                    // close
                    else if (actContent.is(':visible'))
                    {
                        if (allowOpenSlide() === true)
                        {
                            closeSlide(content);
                        }
                    }
                    // }
                });
            };

            // initSlidesx
            const initSlides = () =>
            {
                slide.unbind('mouseenter mouseleave click hover tap');
                head.unbind('mouseenter mouseleave click hover tap');

                // hover ab z.B Desktop....
                if (config.disableHover === false && config.hoverFrom && S.mq(config.hoverFrom, false).matches)
                {
                    head.removeClass('is-active-click');
                    content.hide();
                    initSlidesHover();
                }
                else
                {
                    // click
                    initSlidesClick();

                    // Links nicht folgen sondern JS ausführen slide open/close
                    setPreventDefault();
                }
            };


            // open/close click or hover slides init
            initSlides();

            // set Highlicht
            activeHighlight();


            // close Slides by outside click
            // auch z.B menue icon oeffnen
            $(document).on('click tap', function (e)
            {
                $('body').removeClass('is-keyboard-focus');

                if (!$(e.target).closest($module).length)
                {
                    if (allowOpenSlide() === true)
                    {
                        closeSlide(content);
                        head.removeClass('is-active-click');
                    }
                }
            });

            // window resize
            $(window).on('resize', () =>
            {
                S.delayed('resizeSlide', 250, () =>
                {
                    initSlides();
                    activeHighlight();
                });
            });

            this.toggleKeyTab();
        },

        XXisTouchDevice()
        {
            return typeof window.ontouchstart !== 'undefined';
        },

        toggleKeyTab()
        {
            const $slideHead = this.elements.$slideHead;
            // const $slideContent = this.elements.$slideContent;
            // const slideFrom = this.config.slideFrom;

            // close menue on focusout
            $('#header a').not('#navigation a').on('focus', () =>
            {
                this.close();
            });

            $slideHead.on('focus', (e) =>
            {
                const actContent = $(e.currentTarget).next('.js-slide-content');

                $slideHead.removeClass('is-focus');
                $slideHead.removeClass('is-active-click');
                $slideHead.removeClass('is-keyboard-focus');

                if ($('body').hasClass('is-keyboard-focus'))
                {
                    this.elements.$slideContent.stop().slideUp(this.config.slideUpDelay);

                    setTimeout(() =>
                    {
                        // $(e.currentTarget).addClass('is-focus');
                        // actContent.show();
                        // lev2 open
                        if ($(e.currentTarget).hasClass('has-lev2') && actContent.is(':hidden'))
                        {
                            // bei tab level2 augfklappen
                            if (this.config.openLevel2Tab === true)
                            {
                                $(e.currentTarget).click();
                                // keyboard focus auf current target highlight in mobile moglich für klappermenue
                                $(e.currentTarget).addClass('is-keyboard-focus');
                                // $('body').addClass('is-keyboard-focus');
                            }
                        }
                    }, 25);
                }

                // todos check
                // if (slideFrom && S.mq(slideFrom, true).matches)
                // {
                //     $slideHead.removeClass('is-focus');
                //     $slideHead.removeClass('is-active-click');
                //     $slideContent.hide();
                // }
            });

            // Keysteuerung
            $slideHead.on('keydown', (e) =>
            {
                const actContent = $(e.currentTarget).next('.js-slide-content');

                // console.log(actContent);
                // remove current focus from closed nav
                // xx $(e.currentTarget).removeClass('is-focus');
                // alert(e.keyCode,e.which);

                // leer oder return (TAB = 9)
                if (e.keyCode === 13 || e.which === 32)
                {
                    // // open act slide
                    // // console.log(actContent.text());

                    // this.elements.$slideContent.stop().slideUp(this.config.slideUpDelay);
                    // $slideContent.hide();
                    setTimeout(function ()
                    {
                        // toggle content mit enter
                        actContent.show();
                        $(e.currentTarget).addClass('is-active-click');
                    }, 25);
                }
                else if (e.keyCode === 27)
                {
                    // escape
                    actContent.hide();

                    // check nur mobile
                    // ggf Menunavpunkte überspringen
                    S.header.closeMobileNav();

                    // $(e.currentTarget).focus(); check focus after escape geht so nicht
                    setTimeout(function ()
                    {
                        $(e.currentTarget).removeClass('is-active-click');
                        $(e.currentTarget).removeClass('is-focus');
                    }, 25);
                }
            });

            // check qs
            // Keysteuerung escape
            $('.js-slide-content a').on('keydown', (e) =>
            {
                const actContent = $(e.currentTarget).closest('.js-slide-content');
                const actHead = actContent.prev('.js-slide-head');

                // escape
                if (e.keyCode === 27)
                {
                    this.$module.find('.js-slide-head').removeClass('is-active-click');
                    actContent.hide();
                    actHead.focus();
                }
            });
        },

        // open all slides
        openAllSlides()
        {
            this.elements.$slideContent.show();
            setTimeout(function ()
            {
                $('#navigation').addClass('is-menue-open');
            }, 10);
        },

        close()
        {
            this.elements.$slideContent.stop().slideUp(this.config.slideUpDelay);
            this.elements.$slideHead.removeClass('is-active-click');
        },

        hide()
        {
            this.elements.$slideContent.stop().hide();
            this.elements.$slideHead.removeClass('is-active-click');
        },
    };
